// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as CallerDetailsEntityMapper from "../entity-mapper/CallerDetailsEntityMapper.bs.js";

var execute = CallerDetailsEntityMapper.execute;

var PretendAsCallerResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var PretendAsCallerResponseConverter = partial_arg(PretendAsCallerResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  PretendAsCallerResponseConverterConfig ,
  PretendAsCallerResponseConverter ,
  
}
/* PretendAsCallerResponseConverter Not a pure module */
